module.exports = __webpack_public_path__ + "img/CW.e4e4bc4f.png";